export function getDifferenceInHours(date: Date): number {
  const currentDate = new Date();
  return Math.abs(Math.round((currentDate.getTime() - date.getTime()) / 36e5));
}
